import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Reactportal from "../../../Reactportal/Reactportal";
import VirtualTable from "../../../VirtualTable/VirtualTable";
import { LoadTable } from "../../..";
import PortalFooter from "../../../Reactportal/PortalFooter";
import { useModalContext } from "../../../Reactportal/ModalContext";

const SelectBills = ({ addLR, show, TypeOfPortal, fielddata, setAutoLR, parentID, data, SelectedData = [] }) => {
  const [openLRModal, setOpenLRModal] = useState(show);
  // eslint-disable-next-line
  const [alldata, setalldata] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [selectedFirst, setSelectedFirst] = useState([]);
  const { pushModal, popModal, getTopModal } = useModalContext();
  const Form_Key = "LR_Material_Table";
  const SelectedRowsData = useSelector((store) => store?.UniqueTableReducer?.Main_Data?.Selected_Rows);
  const SelectedRowsData1 = useSelector((store) => store?.UniqueTableReducer?.Selected_Data?.Selected_Rows);
  // const SelectedRowsData2 = useSelector((store) => store?.FormFieldData?.salesBillselectedRows);

  // const dispatch = useDispatch();
  useEffect(() => {
    console.log(SelectedRowsData);
    setCombinedData(SelectedRowsData);
  }, [SelectedRowsData]);
  const SelectAndCancle = () => {};

  return (
    <>
      {openLRModal ? (
        <Reactportal open={openLRModal} onClose={setAutoLR} TypeOfPortal={TypeOfPortal}>
          <div className="mainpickup lr-table-container">
            <div className="pickupdata1">
              {!data?.length ? (
                <p style={{ textAlign: "center" }}>CN not available</p>
              ) : (
                <VirtualTable
                  data={data}
                  title={"Main_Data"}
                  selectedRows={SelectedData}
                  multiSelect={true}
                  ledgerTable=""
                  dragDrop={false}
                />
              )}
            </div>
            {data?.length ? (
              <div className="pickupdata1">
                {!combinedData?.length ? (
                  <p style={{ textAlign: "center" }}>No LR Selected</p>
                ) : (
                  <LoadTable
                    data={combinedData}
                    loading={false}
                    error={null}
                    title={"Selected_Data"}
                    selectedRows={combinedData}
                  />
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <PortalFooter
            Cancletype={"OK"}
            renderContent={() => <></>}
            disabled={false}
            handleformclose={SelectAndCancle}
          />
        </Reactportal>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default SelectBills;
